export default "assets/images/pattern-light-27f6120d.jpg";